import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TalabatLogo from "../../Assets/gfx/talabat.svg";
import DailyInfo from "../../Components/DailyInfo";
import UserNavigation from "../UserNavigation";
import { MopedIcon } from "../../Components/Icons/MopedIcon";
import { ChatIcon } from "../../Components/Icons/ChatIcon";
import { DashboardIcon } from "../../Components/Icons/DashboardIcon";
import { useUser } from "../../Context/UserProvider";

interface FunctionsMenuProps {}

const ChevronRight = () => (
    <>
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
            <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
            <g transform="matrix(-1,0,0,1,5.71937,0)">
                <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    </>
);

const FunctionsMenu: React.FunctionComponent<FunctionsMenuProps> = () => {

  const { t } = useTranslation();
  const { user } = useUser();

    //const totalQuantity = 15;

  return (
    <div className="view-container view-container--stretch background">
      <div className="view-content h-full flex flex-col justify-between">
        <div>
          <div className="navigationbar mb-6">
            <div className="navigationbar__left"></div>
            <div className="navigationbar__center">
              <img src={TalabatLogo} width="95" height="20" style={{minWidth: '95px'}} alt="Talabat" />
            </div>
            <div className="navigationbar__right">
              <UserNavigation />
            </div>
          </div>

          <DailyInfo />
        </div>

        <div className="card-list card-list--gap-10 mt-6">
            <div className="heading text-white font-300">
              {t("Menu")}
            </div>

            {user?.ai_enabled && (
                <Link to={"/ai-check-start"} className="nav-card justify-between">
                    <div className="flex items-center gap-4">
                        <div className="rounded-icon" style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)" }}>
                            <span style={{ fontSize: "18px" }}>🧠</span>
                        </div>
                        <div className="nav-card__title">{t("AI Check")}</div>
                    </div>
                    <ChevronRight />
                </Link>
            )}

            <Link to={"/rider/search"} className="nav-card justify-between">
              <div className="flex items-center gap-4">
                  <div className="rounded-icon">
                    <MopedIcon/>
                  </div>
                  <div className="nav-card__title">{t("Rider Search")}</div>
                </div>
                <ChevronRight />
            </Link>

            <Link to={"/quests"} className="nav-card justify-between">
                <div className="flex items-center gap-4">
                    <div className="rounded-icon">
                        <ChatIcon/>
                    </div>
                    <div className="nav-card__title">{t("Quests")}</div>
                </div>
                <ChevronRight />
            </Link>

            <Link to={"/dashboard"} className="nav-card justify-between">
                <div className="flex items-center gap-4">
                  <div className="rounded-icon">
                    <DashboardIcon/>
                  </div>
                  <div className="nav-card__title">{t("Dashboard")}</div>
                </div>
                <ChevronRight />
            </Link>
          </div>
        </div>
      </div>

    );
  };

  export default FunctionsMenu;
